export default __webpack_public_path__ + "static/media/pictogramCashFlow48.d8f56731.svg";